module.exports = __webpack_public_path__ + "img/34.0e8b5986.png";